module.exports = __webpack_public_path__ + "./fonts/Simple-Line-Icons.2a103029dda6ab1bc9c8b0ee72536e41.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0
// module id = ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0
// module chunks = 14